// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vz-app-header[data-v-18eb582e]{z-index:var(--header-index)}.vz-title-details[data-v-18eb582e]{z-index:var(--modal-overlay-index)}.vz-app-dialog[data-v-18eb582e]{z-index:var(--dialog-index)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
